import React, { useContext, useEffect, useState } from 'react'
import { Card, CardBody, IconButton, Checkbox, Spinner, Tooltip } from "@material-tailwind/react";
import { Pagination, SearchAndAddBtn, Dropdowns, THead } from '../../Components';
import { get_feedback_DropDownList, get_feedback } from '../../Controller/actions';
import { NewContext } from '../../Context/NewContext';
import { RiDeleteBinLine } from 'react-icons/ri';
import { TiClipboard } from 'react-icons/ti'
import { IoEyeOutline } from 'react-icons/io5';
import FeedbackModel from '../../Components/Modals/FeedbackModel';
import { TbLayout2 } from 'react-icons/tb';
import FeedbackPreview from '../../Components/Modals/FeedbackPreview';
import { AiOutlineAndroid } from 'react-icons/ai';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { toast } from 'react-toastify';
import moment from 'moment';
import { DatePicker, Space } from 'antd';
const { RangePicker } = DatePicker;

export const Feedback = ({ title }) => {
    const { permissions, tokenType, setopenPreview, setDeleteUpdateTag, setDeleteUpdateItem, setAddEditDeleteTag, capitalalizeFirstletter, setFormData, confirmationModalShow, setConfirmationModalShow, isLoading, deleteUpdateTag, checkedValues, handleCheckboxChange, currentPage, totalPage, perPage, search, setDeleteUpdateYes, setIsLoading, setCurrentPage, setPerPage, setTotalPage, currentPageData, setCurrentPageData, filterDropdown, handleOpen, isAscending, sortData, selectedDates } = useContext(NewContext);
    const simpleFields = [
        { name: "App", sortable: true, field: 'appName' },
        { name: "Version", sortable: true, field: 'appVersion' },
        { name: "Date", sortable: true, field: 'createdAt' },
        { name: "Category", field: 'category' },
        { name: "Feedback", field: 'Feedback' },
        { name: "Image" },
    ];
    const [pagePermissions, setPagePermissions] = useState({
        CU: true,
        R: true,
        D: true
    });
    const dropdownFields = [{}];
    const totalFields = simpleFields.length + dropdownFields.length + 2;

    const [appNamelist, setAppNamelist] = useState([]);
    const [version, setVersion] = useState([]);
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipId, setTooltipId] = useState();

    useEffect(() => {
        if (tokenType === 'ldap') {
            const update = permissions?.subPermissions?.find((route) => route.name === 'Feedback_message');
            setPagePermissions({ ...pagePermissions, CU: update?.CU, R: update?.R, D: update?.D })
        }
    }, [tokenType, permissions])

    useEffect(() => {
    }, [pagePermissions])


    const DropDownList = async () => {
        const DropDownData = await get_feedback_DropDownList();
        DropDownData?.data?.appName?.map(_ele => setAppNamelist(_prev => !appNamelist.includes(_prev) && [..._prev, { id: _ele._id, label: capitalalizeFirstletter(_ele) }]))
        DropDownData?.data?.appVersion?.map(_ele => setVersion(_prev => !version.includes(_prev) && [..._prev, { id: _ele._id, label: capitalalizeFirstletter(_ele) }]))
    }
    useEffect(() => {
        DropDownList();
    }, [])

    const FilterDropdowns = ({ appNamelist, version, }) => {
        return (
            <div className='flex gap-2.5'>
                <Dropdowns title={`Application`} name={`appName`} Icon={TbLayout2} dropData={appNamelist} />
                <Dropdowns title={`Version`} name={`version`} Icon={AiOutlineAndroid} dropData={version} />
            </div>

        )
    }

    const getfeedbackData = async (_currentPage = 1, sortName = sortData, sortType = isAscending, startDate, endDate) => {

        setIsLoading(true);
        try {
            const getfeedback = await get_feedback(_currentPage, perPage, search, filterDropdown, sortName, sortType, startDate, endDate);
            if (getfeedback) {
                const { status, data, currentPage, perPage, totalPage } = getfeedback;
                if (status) {
                    setCurrentPageData(data);
                    setCurrentPage(currentPage);
                    setPerPage(perPage);
                    setTotalPage(totalPage || 1);
                } else {
                    setCurrentPageData([]);
                    setTotalPage(0);
                }
            }
        } catch (error) {
            console.error(error);
        }
        setIsLoading(false);
    }

    useEffect(() => {
        const [startDate, endDate] = selectedDates;
        getfeedbackData(currentPage, sortData, isAscending, startDate, endDate);
        setDeleteUpdateTag("");
    }, [deleteUpdateTag, search, currentPage, perPage, filterDropdown, pagePermissions, sortData, isAscending, selectedDates]);

    useEffect(() => {
        document.title = title;
    }, [title])

    const handleTooltip = (id) => {
        id === tooltipId ? setShowTooltip(!showTooltip) : setShowTooltip(true)
    }

    const copyText = (data) => {
        navigator.clipboard.writeText(data)
        toast.success("Data Copied Successfully")
    }

    return (
        <>
            <SearchAndAddBtn title={`Feedback`} addBtn={false} excelBtn={true} datePicker={true} FilterDropdowns={<FilterDropdowns appNamelist={appNamelist} version={version} />} deleteUpdateTag='all-delete-feedback' />
            <Card className="overflow-hidden w-full rounded-md shadow-none">
                <CardBody className="overflow-x-auto w-100 py-2.5 px-[5px] card-body-scrollbar">
                    <table className="w-full min-w-max table-auto text-left ">
                        <THead simpleFields={simpleFields} />
                        <tbody>
                            {
                                isLoading ?
                                    <tr>
                                        <td colSpan={totalFields} className='py-12'>
                                            <div className="flex justify-center items-center">
                                                <Spinner />
                                            </div>
                                        </td>
                                    </tr>
                                    : currentPageData?.length === 0 ?
                                        <tr>
                                            <td colSpan={totalFields} className='py-12 bg-gray-200'>
                                                <div className="flex justify-center items-center">
                                                    No Data Found
                                                </div>
                                            </td>
                                        </tr>
                                        : currentPageData?.map((_ele, i) => {
                                            const isLast = i === currentPageData?.length - 1;
                                            const classes = `text-[#1E1627] ${isLast ? "p-4" : "p-[14.5px]"}`;

                                            return (
                                                <tr key={i} className='border-b border-blue-gray-50'>
                                                    <td className={classes}>
                                                        <Checkbox
                                                            className='w-[18px] h-[18px] border-[1.5px] rounded-[3.6px] border-[#1E3354] checked:bg-[#0047FF] checked:border-transparent'
                                                            id={`slider-${_ele._id}`}
                                                            value={`${_ele._id}`}
                                                            disabled={!pagePermissions?.CU}
                                                            checked={checkedValues.includes(`${_ele._id}`)}
                                                            onChange={() => handleCheckboxChange(`${_ele._id}`)}
                                                        />
                                                    </td>

                                                    <td className={classes}>
                                                        <div className="flex items-center">
                                                            <span className={`font-normal text-[17px] ${!_ele?.appName && !_ele?.userId?.appName && `text-gray-500`}`}>{_ele?.appName ? _ele?.appName : _ele?.userId?.appName ? _ele?.userId?.appName : `None`}</span>
                                                        </div>
                                                    </td>
                                                    <td className={classes}>
                                                        <div className="flex items-center">
                                                            <span className={`font-normal text-[17px] ${!_ele?.appVersion && !_ele?.userId?.appVersion && `text-gray-500`}`}>{_ele?.appVersion ? _ele?.appVersion : _ele?.userId?.appVersion ? _ele?.userId?.appVersion : `None`}</span>
                                                        </div>
                                                    </td>
                                                    <td className={classes}>
                                                        <div className="flex items-center">
                                                            <span className={`font-normal text-[17px] ${(!_ele?.createdAt && !_ele?.userId?.createdAt) ? 'text-gray-500' : ''}`}>
                                                                {
                                                                    _ele?.createdAt ?
                                                                        moment(_ele?.createdAt).format('DD/MM/YYYY, hh:mm A') :
                                                                        (_ele?.userId?.createdAt ? moment(_ele?.userId?.createdAt).format('DD/MM/YYYY, hh:mm A') : 'None')
                                                                }
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td className={`${classes}`}>
                                                        <span className='flex items-center'>
                                                            <span>
                                                                {
                                                                    (_ele?.category || _ele?.subCategory || _ele?.subCategoryId?.name || _ele?.categoryId?.name) ? <><div className="flex items-center">
                                                                        <span className={`!w-40 block truncate font-normal text-[17px] ${!_ele?.category && !_ele?.categoryId?.name && `text-gray-500`}`}>{_ele?.category ? _ele?.category : _ele?.categoryId?.name ? _ele?.categoryId?.name : `None`}  </span>
                                                                    </div>
                                                                        <div className="flex items-center">
                                                                            <span className={`!w-40 block truncate font-normal text-[14px] ${!_ele?.subCategory && !_ele?.subCategoryId?.name && `text-gray-500`}`}>{_ele?.subCategory ? _ele?.subCategory : _ele?.subCategoryId?.name ? _ele?.subCategoryId?.name : `None`}  </span>
                                                                        </div></> : <span className='text-gray-500'>None</span>
                                                                }
                                                            </span>
                                                            {
                                                                ((_ele?.category && _ele?.category?.length > 25) || (_ele?.subCategory && _ele?.subCategory?.length > 25) || (_ele?.categoryId?.name && _ele?.categoryId?.name?.length > 25) || (_ele?.subCategoryId?.name && _ele?.subCategoryId?.name?.length > 25)) &&
                                                                <Tooltip placement="right-start" content={
                                                                    <>
                                                                        <div className="p-2 w-[300px] h-48 2xl:w-[400px] overflow-y-auto">
                                                                            {
                                                                                _ele?.category || _ele?.categoryId?.name ? <p key={i} className={`font-normal text-[17px] block text-[#F62929]`}>Category : {_ele?.category ? _ele?.category : _ele?.categoryId?.name ? _ele?.categoryId?.name : `None`} </p> : <span className='text-gray-500'>None</span>
                                                                            }

                                                                            {
                                                                                _ele?.subCategory || _ele?.subCategoryId?.name ? <p key={i} className={`font-normal text-[17px] block text-[#F62929]`}>SubCategory : {_ele?.subCategory ? _ele?.subCategory : _ele?.subCategoryId?.name ? _ele?.subCategoryId?.name : `None`} </p> : <span className='text-gray-500'>None</span>
                                                                            }
                                                                        </div>
                                                                    </>
                                                                }>
                                                                    <InformationCircleIcon strokeWidth={2} className="text-[#1E1627] w-5 h-5 cursor-pointer" />
                                                                </Tooltip>
                                                            }

                                                        </span>
                                                    </td>

                                                    <td className={`${classes}`}>
                                                        <span className='flex items-center'>
                                                            <span>
                                                                {
                                                                    _ele?.feedbackText ? <span className={`!w-52 block truncate font-normal text-[17px] ${!_ele?.feedbackText && `text-gray-500`} cursor-pointer`} >{_ele?.feedbackText || `None`}</span> : <span className='text-gray-500'>None</span>
                                                                }
                                                            </span>
                                                            {
                                                                _ele?.feedbackText && _ele?.feedbackText?.length > 25 &&
                                                                <div className='relative'>

                                                                    <InformationCircleIcon onClick={() => { setTooltipId(i); handleTooltip(i) }} strokeWidth={2} className="text-[#1E1627] w-5 h-5 cursor-pointer " />
                                                                    {(tooltipId === i && showTooltip) && <div>
                                                                        <div className={`${(i === 0 || i === 1) ? 'top-0' : 'bottom-0'} absolute z-50 left-12 `}>
                                                                            <div className='p-2 w-[280px] h-60 2xl:w-[380px] overflow-y-scroll bg-black text-white'>
                                                                                {_ele?.feedbackText}
                                                                            </div>
                                                                        </div>
                                                                    </div>}

                                                                </div>

                                                            }
                                                            <TiClipboard className='cursor-pointer w-5 h-5' onClick={() => { copyText(_ele?.feedbackText) }} />
                                                        </span>
                                                    </td>

                                                    {
                                                        _ele?.feedbackImages?.length > 0 ? <td className={`${classes} cursor-pointer`} onClick={() => { setAddEditDeleteTag(`view`); setFormData(_ele); setopenPreview(true); }}>
                                                            <div className="mt-2 flex justify-start -gap-4">
                                                                {
                                                                    _ele?.feedbackImages?.map((item, i) => {
                                                                        return (
                                                                            <>
                                                                                <img src={item} alt="" className={`rounded-lg  w-14 ${i > 0 ? '-ml-8' : ''}`} />
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </td> : <div className="mt-2 flex justify-start -gap-4"></div>
                                                    }

                                                    <td className={classes}>
                                                        <div className="flex items-center gap-2">
                                                            {/* <IconButton className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none' onClick={() => { setDeleteUpdateYes("update-feedback"); setAddEditDeleteTag(`update`); setFormData(_ele); handleOpen() }}>
                                                                <BiEdit />
                                                            </IconButton> */}
                                                            <IconButton className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none' disabled={!pagePermissions?.CU} onClick={() => { setAddEditDeleteTag(`view`); setFormData(_ele); handleOpen() }}>
                                                                <IoEyeOutline />
                                                            </IconButton>
                                                            <IconButton className='bg-[#EAEDF3] text-[#F62929] text-[21px] shadow-none hover:shadow-none' disabled={!pagePermissions?.D} onClick={() => { setDeleteUpdateYes("delete-feedback"); setDeleteUpdateItem({ id: _ele._id, name: _ele.name }); setConfirmationModalShow(!confirmationModalShow) }}>
                                                                <RiDeleteBinLine />
                                                            </IconButton>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                            }
                        </tbody>
                    </table>
                </CardBody>
            </Card>
            {
                totalPage > 1 &&
                <Pagination currentPage={currentPage} totalPage={totalPage} getData={getfeedbackData} />
            }
            <FeedbackModel />
            <FeedbackPreview />
        </>
    )
}
Feedback.defaultProps = {
    title: "Message | Feedback"
};



export default Feedback
